import React, { useState } from "react";
import PropTypes from "prop-types";
import { AlertTriangle, Textarea } from "@opendate-app/setlist";
import DecisionModal from "../ClassesShared/DecisionModal";

const REASON_ID = "cancel-class-reason";

const registrationsPhrase = (count) => (count === 1 ? "The 1 registration" : `All ${count} registrations`);

export function cancelClassDescription(classLabel, registrationCount, paidCount) {
  const subject = classLabel ? `“${classLabel}”` : "this class";
  const parts = [];
  if (registrationCount > 0) parts.push(`${registrationsPhrase(registrationCount)} for ${subject} will be canceled, and confirmed attendees get a cancellation email.`);
  if (paidCount == null && registrationCount > 0) parts.push("Anyone with a payment left to refund gets it back on their original payment method.");
  if (paidCount > 0) parts.push(`${paidCount === 1 ? "1 paid registration is" : `${paidCount} paid registrations are`} refunded to the original payment method.`);
  if (parts.length === 0) return `Canceling ${subject} can't be undone.`;
  return `${parts.join(" ")} This can't be undone.`;
}

function CancelClassModal({ classLabel, registrationCount = 0, paidCount, requireReason, onClose, onConfirm, working }) {
  const hasRegistrations = registrationCount > 0 || paidCount > 0;
  const [reason, setReason] = useState("");
  const [reasonError, setReasonError] = useState(null);
  const refunds = paidCount == null ? hasRegistrations : paidCount > 0;

  const confirm = () => {
    if (requireReason && !reason.trim()) {
      setReasonError("Enter a reason to cancel a published class.");
      document.getElementById(REASON_ID)?.focus();
      return;
    }
    onConfirm(reason);
  };

  return (
    <DecisionModal
      type="error"
      icon={AlertTriangle}
      title="Cancel this class?"
      description={cancelClassDescription(classLabel, registrationCount, paidCount)}
      cancelLabel="Keep Class"
      confirmLabel={working ? "Canceling…" : refunds ? "Cancel & Refund" : "Cancel Class"}
      onClose={onClose}
      onConfirm={confirm}
      working={working}
    >
      <Textarea
        id={REASON_ID}
        required={requireReason}
        error={reasonError}
        label={requireReason ? "Cancellation reason (visible to learners)" : "Cancellation reason"}
        rows={3}
        placeholder="Tell learners why this class is being canceled."
        hint={requireReason ? "A reason is required to cancel a published class." : undefined}
        value={reason}
        onChange={(e) => { setReason(e.target.value); setReasonError(null); }}
      />
    </DecisionModal>
  );
}

CancelClassModal.propTypes = {
  classLabel: PropTypes.string,
  registrationCount: PropTypes.number,
  paidCount: PropTypes.number,
  requireReason: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  working: PropTypes.bool,
};

export default CancelClassModal;
